import React from "react";
import { Link, useNavigate } from "react-router-dom";
import motabilityLogo from '../../assets/img/logos/motability-scheme.svg';
import scooterIcon from '../../assets/img/icons/scooter.png';
import BasketTimer from './BasketTimer';
import { useBasket } from '../../context/BasketContext';
import axios from "axios";
import { API_BASE_URL } from '../../constants/api';

const Header = () => {
    const { basket } = useBasket();
    const slotCount = basket?.slots?.length || 0;
    const isLoggedIn = !!localStorage.getItem('ambassador_token');
    // Scooter/wheelchair slots carry a vehicle_type; the vehicle-booking flow slots do not.
    const hasScooterSlot = basket?.slots?.some(
        (slot) => slot.vehicle_type === 'scooter' || slot.vehicle_type === 'wheelchair'
    );
    const basketPath = hasScooterSlot ? '/scooter-checkout' : '/basket-confirmation';

    const navigate = useNavigate();

    const handleLogout = async () => {
        
        const token = localStorage.getItem('ambassador_token');

        try{
            const resp = await axios.post(`${API_BASE_URL}/logout`, {}, {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'multipart/form-data'
                },
                withCredentials: true
            });
        } catch (error) {
            console.log(error);
        }

        await localStorage.removeItem('ambassador_token');
        await localStorage.removeItem('ambassador_id');
        navigate('/ambassador-login');
    };

    return (
        <header className="bg-primary sticky-top py-11 py-xl-4" id="main-header">
            <div className="navigation">
                <div className="container-fluid px-0">
                    <nav className="navbar py-0 ps-3 ps-xxl-96 pe-xxl-264">
                        <span className="navbar-brand py-0 me-xl-29">
                            <img
                                src={motabilityLogo}
                                alt="Motability Scheme"
                                className="img-fluid w-144 w-xl-auto"
                                width="350"
                                height="90"
                                fetchPriority="low"
                                decoding="async"
                                loading="lazy"
                            />
                        </span>

                        <div className="d-xl-flex align-items-center flex-xl-wrap">
                            <ul className="navbar-nav list-unstyled d-none d-xl-flex flex-row align-items-center gap-60 mb-0">
                                {isLoggedIn && (
                                <li className="nav-item">
                                    <Link to="/event-select" className="nav-link d-flex align-items-center gap-2 p-0">
                                        <i className="icon-car" aria-hidden="true"></i>
                                        Book Vehicles
                                    </Link>
                                </li>
                                )}

                                {isLoggedIn && (
                                    <li className="nav-item">
                                        <Link to="/scooter-event-select" className="nav-link d-flex align-items-center gap-2 p-0">
                                            <img src={scooterIcon} alt="" aria-hidden="true" style={{ height: '24px', width: 'auto' }} />
                                            Book Scooters
                                        </Link>
                                    </li>
                                )}

                                {slotCount > 0 && <li className="nav-item d-flex flex-column align-items-center">
                                    <BasketTimer />
                                    <Link to={basketPath} className="nav-link d-flex align-items-center gap-2 p-0 count position-relative">
                                        <i 
                                            className="icon-basket" 
                                            aria-hidden="true" 
                                            data-bs-toggle="tooltip" 
                                            data-bs-title="Checkout session ends in 27:55" 
                                            data-bs-placement="top" 
                                            data-bs-trigger="manual" 
                                            data-bs-custom-class="checkout-tooltip d-none d-xl-block"
                                        ></i>
                                        {slotCount > 0 && (
                                            <span 
                                                className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger"
                                                style={{
                                                    fontSize: '0.75rem',
                                                    padding: '0.25rem 0.5rem',
                                                    transform: 'translate(-50%, -50%)'
                                                }}
                                            >
                                                {slotCount}
                                            </span>
                                        )}
                                        Basket
                                    </Link>
                                </li>}

                                {isLoggedIn && (
                                <li className="nav-item">
                                    <Link onClick={handleLogout} className="nav-link d-flex align-items-center gap-2 p-0">
                                        <i className="icon-person-silhouette" aria-hidden="true"></i>
                                        Logout
                                    </Link>
                                </li>
                                )}

                                {isLoggedIn && (
                                <li className="nav-item">
                                    <Link to="/event-select" className="btn btn-secondary d-flex align-items-center text-motability-white ms-15 me-43">
                                        Book your test drive
                                    </Link>
                                </li>
                                )}
                            </ul>

                            <div className="collapse navbar-collapse position-absolute w-100 start-0 top-56 top-xl-108" id="main-navigation">
                                <div className="d-flex flex-column flex-xl-row align-items-center justify-content-xl-end">
                                    <ul className="mobile-nav d-xl-none navbar-nav bg-primary w-100" id="mobile-navigation-menu">
                                        {isLoggedIn && (
                                        <li className="nav-item border-top border-motability-light-blue-25">
                                            <Link to="/book-vehicle-step-1b" className="nav-link d-flex align-items-center gap-2 lh-120 px-3">
                                                <i className="icon-car" aria-hidden="true"></i>
                                                Book Vehicles
                                            </Link>
                                        </li>
                                        )}

                                        {isLoggedIn && (<li className="nav-item border-top border-motability-light-blue-25">
                                            <Link to="/scooter-event-select" className="nav-link d-flex align-items-center gap-2 lh-120 px-3">
                                                <img src={scooterIcon} alt="" aria-hidden="true" style={{ height: '24px', width: 'auto' }} />
                                                Book Scooters
                                            </Link>
                                        </li>
                                        )}

                                        <li className="nav-item border-top border-motability-light-blue-25">
                                            <Link to="#" className="nav-link d-flex align-items-center gap-2 lh-120 px-3">
                                                <i className="icon-person-silhouette" aria-hidden="true"></i>
                                                Account
                                            </Link>
                                        </li>

                                        {slotCount > 0 && <li className="nav-item border-top border-motability-light-blue-25">
                                            <Link to={basketPath} className="nav-link d-flex align-items-center gap-2 lh-120 px-3 count position-relative">
                                                <i className="icon-basket" aria-hidden="true"></i>
                                                {slotCount > 0 && (
                                                    <span 
                                                        className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger"
                                                        style={{
                                                            fontSize: '0.75rem',
                                                            padding: '0.25rem 0.5rem',
                                                            transform: 'translate(-50%, -50%)'
                                                        }}
                                                    >
                                                        {slotCount}
                                                    </span>
                                                )}
                                                Basket
                                            </Link>
                                        </li>}
                                    </ul>

                                    {isLoggedIn && (
                                    <ul className="list-unstyled bg-primary w-100 d-xl-none mb-0">
                                        <li className="border-top border-motability-light-blue-25 d-flex justify-content-center justify-content-md-start px-3">
                                            <Link to="#" className="btn btn-secondary d-flex align-items-center justify-content-center text-motability-white my-10">
                                                Book your test drive
                                            </Link>
                                        </li>
                                    </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header; 